import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-database-2-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                Basetao Sheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Independent educational platform about product research and shopping strategies. Not affiliated with Basetao officially.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Basetao Spreadsheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Popular Topics
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Basetao Review
                </Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Coupon & Discounts
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              Shop Categories
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Hoodies & Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Jackets
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Accessories
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Sheet Knowledge Hub. All rights reserved. Not affiliated with Basetao.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
              Terms
            </Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}